<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Reason Codes" | tenantWords}}</h2>
      <span class="page-subtitle">Reasons recorded on {{"inventory" | tenantWords}} adjustments and moves</span>
    </div>
    <div class="header-actions">
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="openEdit()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>New {{"Reason Code" | tenantWords}}
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <div class="search-box">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" placeholder="Search reason codes..." [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()"
        class="search-input" aria-label="Search reason codes">
    </div>
  </div>

  <div class="grid-card">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.reasonCodes" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings"
      [enableStickyHeader]="true" [enableHover]="true" (rowSelected)="onRowSelected($event)">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let code of this.reasonCodes | slice:0:mobileVisibleCount; trackBy: trackByCode" (click)="openEdit(code)">
      <div class="m-card-top">
        <span class="m-card-name">{{code.reason || '—'}}</span>
        <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.reasonCodes.length && !this.isLoading">
      <fa-icon [icon]="faListCheck" class="m-empty-icon"></fa-icon>
      <div>No reason codes match your search</div>
    </div>

    <button class="m-show-more" *ngIf="this.reasonCodes.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.reasonCodes.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #actionTemplate let-data>
  <fa-icon [icon]="faChevronRight" class="row-chevron"></fa-icon>
</ng-template>
